export const about = {
  // Hero
  heroTitle: 'Dynamix Hakkında',
  heroSubtitle: 'Yenilikçi çelik donatı teli çözümleriyle beton güçlendirmenin geleceğine öncülük ediyoruz.',
  
  // Our Story
  storyTitle: 'Hikayemiz',
  storyP1: 'DYNAMIX, güçlendirilmiş beton yapılar için yüksek performanslı çelik donatı teli üretiminde yenilikçi bir markadır. İnşaat sektörünün gelişen ihtiyaçlarına mühendislik odaklı çözümler sunmak için kurulmuş olan Dynamix, dayanıklılığı artıran, uygulama kolaylığı sağlayan ve kaliteyi standartlaştıran ürünleriyle öne çıkmaktadır.',
  storyP2: 'Çorlu, Tekirdağ merkezli olarak, yenilik, kalite ve yapısal bütünlük taahhüdümüzle inşaat sektörüne yeni bir soluk getiriyoruz. Son teknoloji üretim tesisimiz, en zorlu uluslararası standartları karşılayan çelik donatı telleri üretmek için ileri teknolojiyi uzman işçilikle birleştiriyor.',
  storyP3: 'Her çelik donatı telinde mühendisliğimizin izini, her projede güvenin temelini taşıyoruz.',
  
  // Mission & Vision
  missionTitle: 'Misyonumuz',
  missionDesc: 'Dünya çapında beton yapıların dayanıklılığını ve güvenliğini artıran yenilikçi, yüksek kaliteli çelik donatı teli çözümleri sağlamak. Kaliteyi sadece ürünümüze değil, sürdürülebilirlik ve şeffaflık ilkeleriyle süreçlerimize de entegre ediyoruz.',
  
  visionTitle: 'Vizyonumuz',
  visionDesc: 'Beton güçlendirme teknolojilerinde yapıların ömrünü uzatmak, işçilik maliyetlerini azaltmak ve sektöre değer katmak. Çelik donatı teli inovasyonunda küresel lider olmayı, kalite ve performans için yeni standartlar belirlemeyi hedefliyoruz.',
  
  // Core Values
  valuesTitle: 'Temel Değerlerimiz',
  valuesSubtitle: 'Yaptığımız her şeye rehberlik eden ilkeler.',
  
  value1Title: 'Kalite Mükemmelliği',
  value1Desc: 'En yüksek üretim standartlarına ve ürün kalitesine taviz vermeden bağlılık.',
  
  value2Title: 'İnovasyon',
  value2Desc: 'Beton güçlendirme teknolojisini ilerletmek için sürekli araştırma ve geliştirme.',
  
  value3Title: 'Dürüstlük',
  value3Desc: 'Şeffaf iş uygulamaları ve tüm paydaşlarla dürüst ilişkiler.',
  
  value4Title: 'Sürdürülebilirlik',
  value4Desc: 'Üretimde çevresel sorumluluk ve dayanıklı inşaat çözümlerini teşvik etme.',
  
  // Why Choose Us
  whyTitle: 'Neden Dynamix',
  whySubtitle: 'Çelik donatı teli sektöründe bizi farklı kılan özellikler.',
  
  why1Title: 'Uzman Ekip',
  why1Desc: 'Deneyimli mühendislerimiz ve teknisyenlerimiz, beton güçlendirme teknolojisi ve malzeme biliminde onlarca yıllık birleşik uzmanlık getiriyor.',
  
  why2Title: 'Modern Altyapı',
  why2Desc: 'İleri üretim teknolojisi ve kalite kontrol sistemleriyle donatılmış son teknoloji üretim tesisi.',
  
  why3Title: 'Uluslararası Standartlar',
  why3Desc: 'Tüm ürünler, çelik donatı teli güçlendirmesi için ASTM A820 ve diğer uluslararası standartlara uygun olarak üretilmiştir.',
  
  why4Title: 'Teknik Destek',
  why4Desc: 'Proje planlamasından uygulamaya kadar kapsamlı teknik yardım, optimal tel seçimi ve uygulamasını sağlar.',
  
  why5Title: 'Güvenilir Teslimat',
  why5Desc: 'Verimli lojistik ve envanter yönetimi, inşaat projelerinizi programda tutmak için zamanında teslimat sağlar.',
  
  why6Title: 'Müşteri Odaklılık',
  why6Desc: 'Her projenin benzersiz gereksinimlerini özelleştirilmiş çözümlerle anlamaya ve karşılamaya adanmıştır.',
  
  // CTA
  ctaTitle: 'Dynamix ile Ortaklık Kurun',
  ctaSubtitle: 'Çelik donatı teli güçlendirme ihtiyaçları için Dynamix\'e güvenen artan sayıda inşaat profesyoneline katılın.',
};
